import types from './types';

// Spaces
const getSpaces = projectId => ({ type: types.GET_SPACES, payload: projectId });
const getSpacesSuccess = spaces => ({ type: types.GET_SPACES_SUCCESS, payload: spaces });
const getSpacesFailure = error => ({ type: types.GET_SPACES_FAILURE, payload: error });

const createSpace = (projectId, spaceData) => ({ type: types.CREATE_SPACE, payload: { projectId, spaceData } });
const createSpaceSuccess = space => ({ type: types.CREATE_SPACE_SUCCESS, payload: space });
const createSpaceFailure = error => ({ type: types.CREATE_SPACE_FAILURE, payload: error });

const updateSpace = (spaceId, spaceData) => ({ type: types.UPDATE_SPACE, payload: { spaceId, spaceData } });
const updateSpaceSuccess = space => ({ type: types.UPDATE_SPACE_SUCCESS, payload: space });
const updateSpaceFailure = error => ({ type: types.UPDATE_SPACE_FAILURE, payload: error });

const deleteSpace = (spaceId, projectId) => ({ type: types.DELETE_SPACE, payload: { spaceId, projectId } });
const deleteSpaceSuccess = () => ({ type: types.DELETE_SPACE_SUCCESS });
const deleteSpaceFailure = error => ({ type: types.DELETE_SPACE_FAILURE, payload: error });

// Assessment
const runAssessment = projectId => ({ type: types.RUN_ASSESSMENT, payload: projectId });
const runAssessmentSuccess = result => ({ type: types.RUN_ASSESSMENT_SUCCESS, payload: result });
const saveAssessment = (projectId, assessmentData) => ({ type: types.SAVE_ASSESSMENT, payload: { projectId, assessmentData } });
const saveAssessmentSuccess = result => ({ type: types.SAVE_ASSESSMENT_SUCCESS, payload: result });
const saveAssessmentFailure = error => ({ type: types.SAVE_ASSESSMENT_FAILURE, payload: error });

const getAssessments = projectId => ({ type: types.GET_ASSESSMENTS, payload: projectId });
const getAssessmentsSuccess = assessments => ({ type: types.GET_ASSESSMENTS_SUCCESS, payload: assessments });
const getAssessmentsFailure = error => ({ type: types.GET_ASSESSMENTS_FAILURE, payload: error });

// BHPS
const getBhpsFeatures = spaceId => ({ type: types.GET_BHPS_FEATURES, payload: spaceId });
const getBhpsFeaturesSuccess = features => ({ type: types.GET_BHPS_FEATURES_SUCCESS, payload: features });
const getBhpsFeaturesFailure = error => ({ type: types.GET_BHPS_FEATURES_FAILURE, payload: error });

const updateBhpsFeatures = (spaceId, features) => ({ type: types.UPDATE_BHPS_FEATURES, payload: { spaceId, features } });
const updateBhpsFeaturesSuccess = () => ({ type: types.UPDATE_BHPS_FEATURES_SUCCESS });
const updateBhpsFeaturesFailure = error => ({ type: types.UPDATE_BHPS_FEATURES_FAILURE, payload: error });

// Population
const getPopulation = projectId => ({ type: types.GET_POPULATION, payload: projectId });
const getPopulationSuccess = data => ({ type: types.GET_POPULATION_SUCCESS, payload: data });
const getPopulationFailure = error => ({ type: types.GET_POPULATION_FAILURE, payload: error });

const savePopulation = (projectId, populationData) => ({ type: types.SAVE_POPULATION, payload: { projectId, populationData } });
const savePopulationSuccess = data => ({ type: types.SAVE_POPULATION_SUCCESS, payload: data });
const savePopulationFailure = error => ({ type: types.SAVE_POPULATION_FAILURE, payload: error });

const deletePopulation = id => ({ type: types.DELETE_POPULATION, payload: id });
const deletePopulationSuccess = () => ({ type: types.DELETE_POPULATION_SUCCESS });
const deletePopulationFailure = error => ({ type: types.DELETE_POPULATION_FAILURE, payload: error });

// Financial ROI (client-side)
const setStaffRoi = data => ({ type: types.SET_STAFF_ROI, payload: data });
const setResidentRoi = data => ({ type: types.SET_RESIDENT_ROI, payload: data });

export default {
  getSpaces, getSpacesSuccess, getSpacesFailure,
  createSpace, createSpaceSuccess, createSpaceFailure,
  updateSpace, updateSpaceSuccess, updateSpaceFailure,
  deleteSpace, deleteSpaceSuccess, deleteSpaceFailure,
  runAssessment, runAssessmentSuccess,
  saveAssessment, saveAssessmentSuccess, saveAssessmentFailure,
  getAssessments, getAssessmentsSuccess, getAssessmentsFailure,
  getBhpsFeatures, getBhpsFeaturesSuccess, getBhpsFeaturesFailure,
  updateBhpsFeatures, updateBhpsFeaturesSuccess, updateBhpsFeaturesFailure,
  getPopulation, getPopulationSuccess, getPopulationFailure,
  savePopulation, savePopulationSuccess, savePopulationFailure,
  deletePopulation, deletePopulationSuccess, deletePopulationFailure,
  setStaffRoi, setResidentRoi,
};
